export enum AppID {
  NAVIGATION = 'single-spa-application:@pmi/navigation',
  INTBDASHBOARD = 'single-spa-application:@pmi/intb-dashboard',
  TBCFDASHBOARD = 'single-spa-application:@pmi/tbcf-dashboard',
  INTB = 'single-spa-application:@pmi/intb',
  TBCF = 'single-spa-application:@pmi/tbcf',
  ALC = 'single-spa-application:@pmi/alc',
  CONTROL = 'single-spa-application:@pmi/control-panel'
};

export enum Routes {
    DASHBOARD = 'dashboard',
    INTB = 'intb',
    TBCF = 'tbcf',
    ALC = 'alc',
    CONTROL = 'control-panel'
};

export interface ContentAppsHtmlStructure {
    intbDashboardApp: HTMLElement,
    tbcfDashboardApp: HTMLElement,
    intbApp: HTMLElement,
    tbcfApp: HTMLElement,
    alcApp: HTMLElement,
    controlApp: HTMLElement,
};
